<template>
    <el-dialog title="查询支出流水" :visible.sync="showDialog" width="800px" @closed="refeshRule">
        <div class="main-button-bar">
            <el-row class="search-row">
                <el-select
                    v-model="page.accountId"
                    clearable
                    placeholder="选择账户"
                    class="search-item"
                >
                    <el-option
                        v-for="item in accounts"
                        :key="item.id"
                        :label="item.number"
                        :value="item.id"
                    ></el-option>
                </el-select>

                <el-input v-model="page.toName" placeholder="收付款方" class="search-item"></el-input>
                已选择: {{selectedSize}} 个
            </el-row>
            <el-row class="search-row">
                <el-date-picker
                    type="date"
                    placeholder="开始变动日期"
                    v-model="page.timeStart"
                    class="search-item"
                    value-format="yyyy-MM-dd"
                ></el-date-picker>
                <el-date-picker
                    type="date"
                    placeholder="截止变动日期"
                    v-model="page.timeEnd"
                    class="search-item"
                    value-format="yyyy-MM-dd"
                ></el-date-picker>

                <el-button type="primary" size="small" @click="list(1)">查询</el-button>
            </el-row>
        </div>

        <el-table
            :data="records"
            stripe
            style="width: 100%"
            :height="this.$tools.mainHeight() - 450"
            class="finance-bill-table-dilaog"
        >
            <el-table-column width="35">
                <template slot-scope="bill">
                    <el-checkbox
                        :label="bill.row.id"
                        @change="handleSelectionChange"
                        v-model="selected"
                    ></el-checkbox>
                </template>
            </el-table-column>
            <el-table-column prop="accountName" label="所属账户" width="100"></el-table-column>
            <el-table-column prop="createTime" label="变动时间" width="160">
                <template slot-scope="bill">{{ $tools.timestampToTime(bill.row.createTime)}}</template>
            </el-table-column>
            <el-table-column prop="changed" label="变动金额" width="100">
                <template slot-scope="bill">{{ $tools.parsecost(bill.row.changed, true)}}</template>
            </el-table-column>
            <el-table-column prop="toName" label="收付款方" width="80" :show-overflow-tooltip="true"></el-table-column>
            
            <el-table-column prop="tagNames" label="标签" width="250" :show-overflow-tooltip="true">
                <template slot-scope="bill">
                    <el-tag class="bill-tags" v-for="tag in toTags(bill.row.tagNames)" :key="tag">{{tag}}</el-tag>
                </template>
            </el-table-column>
        </el-table>

        <el-pagination
            small
            layout="total, prev, pager, next"
            :total="page.total"
            @current-change="list"
            :current-page.sync="page.current"
            :page-size.sync="page.size"
        ></el-pagination>

        <div slot="footer" class="dialog-footer">
            <el-button size="small" class="op-button" @click="showDialog=false">取消</el-button>
            <el-button type="primary" size="small" class="op-button" @click="save">确定</el-button>
        </div>
    </el-dialog>
</template>

<script>
export default {
    props: {
        show: { type: Boolean, default: false },
        preSelected: { type: String, default: null },
        afterSeleted: { type: Function, default: null },
        isMul: { type: Boolean, default: true },
    },
    data() {
        return {
            showDialog: false,
            accounts: null,
            records: null,
            profit: null,
            page: {
                current: null,
                total: null,
                size: 10,
            },
            selected: [],
            selectedSize: 0,
        };
    },
    methods: {
        getAccount() {
            let _this = this;

            _this.$http.post(
                ["finance/account/all"],
                [
                    function (data) {
                        _this.accounts = data;
                    },
                ],
                ".finance-bill-tabnle"
            );
        },
        list(current) {
            let _this = this;

            _this.page.current = current ? current : _this.page.current;

            _this.$http.post(
                ["finance/bill/pageOut", _this.page],
                [
                    function (data) {
                        _this.records = data.records;
                        _this.page.total = data.total;
                    },
                ],
                ".finance-bill-table-dilaog"
            );
        },
        refeshRule() {
            this.selected = [];
            this.selectedSize = 0;
            this.$emit("update:show", false);
        },
        handleSelectionChange() {
            this.selectedSize = this.selected.length;

            if (!this.isMul && this.selectedSize  > 1) {
                this.selectedSize = 1;
                this.selected = [this.selected[1]];
            }
        },
        save() {
            if (this.afterSeleted) {
                this.afterSeleted(this.selected.join(","));
            } else {
                this.$emit("afterSeleted", this.selected.join(","));
            }
            
            this.showDialog = false;
        },
        toTags(tag) {
            return tag ? tag.split(",") : [];
        }
    },
    mounted() {},
    watch: {
        show(val) {

            if (val) {
                if (this.preSelected) {
                    this.selected = this.preSelected.split(",");
                    this.selectedSize = this.selected.length;
                } else {
                    this.selected  = [];
                    this.selectedSize = 0;
                }

                this.getAccount();
                this.list(1);
            }

            this.showDialog = val;
        },
    },
};
</script>

<style lang="scss">
.el-dialog__body {
    padding-top: 10px;
}
#app
    > section
    > section
    > main
    > div
    > div:nth-child(5)
    > div
    > div.el-dialog__body
    > div.el-table.finance-bill-table-dilaog.el-table--fit.el-table--striped.el-table--scrollable-x.el-table--scrollable-y.el-table--enable-row-hover.el-table--enable-row-transition
    > div.el-table__header-wrapper
    > table
    > thead
    > tr
    > th.el-table_2_column_13.el-table-column--selection.is-leaf
    > div
    > label
    > span
    > span {
    display: none !important;
}
.bill-tags {
    margin-right: 5px;
}
</style>